import { Film } from 'lucide-react';
import { useState } from 'react';
import { useApi } from '@/hooks/use-connection';
import { cn } from '@/lib/utils';

/**
 * A cached image by hash, or a quiet placeholder while it is missing: covers arrive
 * after the movie does, since downloads queue behind indexing.
 */
export function AssetImage(props: { readonly file?: string; readonly alt: string; readonly className?: string }) {
  const api = useApi();
  // Remembers which file failed, so moving to another movie (same component, new
  // file) tries the new one instead of keeping the placeholder.
  const [failed, setFailed] = useState<string | undefined>(undefined);
  if (props.file === undefined || failed === props.file) {
    return (
      <div className={cn('flex items-center justify-center bg-muted text-muted-foreground', props.className)}>
        <Film className="size-6 opacity-40" />
      </div>
    );
  }
  const file = props.file;
  return <img src={api.assetUrl(file)} alt={props.alt} loading="lazy" decoding="async" onError={() => setFailed(file)} className={cn('object-cover', props.className)} />;
}
